import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=57643255&scoped=true"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=57643255&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57643255",
  null
  
)

/* custom blocks */
import block0 from "./FooterContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports